import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import BlogPage from './pages/BlogPage';
import BlogPost from './pages/BlogPost';
import AboutUsPage from './pages/AboutUsPage';
import ContactUsPage from './pages/ContactUsPage';
import LegalPage from './pages/LegalPage';
import ProductDetails from './pages/ProductDetails';
import ProductsPage from './pages/ProductsPage';
import WhatsAppButton from './components/WhatsAppButton';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/:slug" element={<ProductDetails />} />
          <Route path="/privacy-policy" element={<LegalPage type="privacy-policy" />} />
          <Route path="/terms-of-service" element={<LegalPage type="terms-of-service" />} />
          <Route path="/cookie-policy" element={<LegalPage type="cookie-policy" />} />
        </Routes>
        <WhatsAppButton />
        <Footer />
      </motion.div>
    </Router>
  );
}

export default App;
